import { gql } from '@apollo/client';

export const listMembershipFilterOptionsQuery = gql`
  query getListMembershipFilterOptions($pagination: Pagination) {
    lists(pagination: $pagination) {
      info {
        count
      }
      results {
        id
        name
        updatedAt
      }
    }
  }
`;

export const otherWorklflowsTriggeringCurrentWorkflowQuery = gql`
  query getOtherWorklflowsTriggeringCurrentWorkflow($id: Long!, $workflowType: WorkflowType!) {
    workflow(id: $id, workflowType: $workflowType) {
      allTriggeredByWorkflows {
        workflow {
          id
          name
          workflowType
          enabled
        }
      }
    }
  }
`;
